'use strict';

/*
  Bank

  An object that represents a Bank resource. Data for this resource is stored through the
  Presenter/Model. Provides convenience methods for working with the resource.

  Parameters:
    presenter [APIPresenter] (required):
        Reference to the APIPresenter where the data for this bank account is stored.
    bankModel [object] (required):
      Raw data fro each bank from banks model.
*/
function Bank(presenter, bankModel) {
  this.presenter = presenter;
  this.id = bankModel.id;
  this.banksArrayIndex = null;

  this._getBanksArrayIndex = function () {
    if (this.banksArrayIndex === null) {
      var banks = this.presenter.getModelProperty('banking.banks.banks');
      for (var i = 0; i < banks.length; i++) {
        if (banks[i].id === this.id) {
          this.banksArrayIndex = i;
          break;
        }
      }
    }
    return this.banksArrayIndex;
  };

  this._providerHasLogo = {
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
    10: true,
    14: true,
    84: true,
    143: true
  };

  this.getBankName = function () {
    return bankModel.name;
  };

  this.getInstitutionId = function () {
    return bankModel.number;
  };

  this.getBankImg = function () {
    var bankId = this.id;
    if (!this._providerHasLogo[this.id]) {
      bankId = 'Generic-Bank';
    }
    return '/member/assets/imgs/bank-icons/' + bankId + '.png';
  };

  this.isPlaidSupported = function () {
    return bankModel.is_plaid_supported;
  };

  this.isPlaidOnline = function () {
    return bankModel.is_plaid_online;
  };

  this.isDltSupported = function () {
    return bankModel.is_dlt_supported;
  };

  this.isVisaDirectSupported = function () {
    return bankModel.is_visa_direct_supported;
  };

  this.isEnabled = function () {
    return bankModel.enabled;
  };

  this.checkConnection = function (callback) {
    var index = this._getBanksArrayIndex();
    if (this.presenter.hasAction('banking.banks.banks[' + index + '].select_bank')) {
      this.presenter.performAction('banking.banks.banks[' + index + '].select_bank', { id: this.id }, null);
    }
    if (typeof callback === 'function') {
      callback(this);
    }
  };
}